module.exports = __webpack_public_path__ + "img/4.5c6c1897.png";